"use client";
import { register } from "swiper/element/bundle";

import styles from "./media-gallery.module.css";
import SwiperGallery from "./SwiperGallery";
register();

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "swiper-container": any;
      "swiper-slide": any;
    }
  }
}

export type SwiperMediaElement = {
  href: string;
  alt: string;
  type: string;
};

type SwiperMedia = SwiperMediaElement[] | undefined;

const MediaGallery = ({ media }: { media: SwiperMedia }) => {
  return (
    <div className={styles.gallery__container}>
      <div className={styles.gallery__container__inner}>
        {/* <Suspense fallback={<Skeleton height="100%" />}> */}
        <SwiperGallery media={media} className={styles.swiper} />
        {/* </Suspense> */}
      </div>
    </div>
  );
};

export default MediaGallery;
